const Footer = ({ data }) => {
    return (
        <footer className="bg-gray-900 text-white">
            <div className="w-full px-2 sm:px-4 md:px-6 lg:px-8 md:mx-auto md:max-w-[1440px] lg:w-[70%] py-10">
                {/* 上部分：Logo + Desc 与 Navigation */}
                <div className="mt-6 md:mt-16 flex flex-col md:flex-row justify-start gap-10">
                    {/* 左侧 Logo + 描述 */}
                    <div className="px-4 md:px-0 w-full md:w-2/5 pr-8">
                        <img src={data.logo} alt="Logo" className="h-12 mb-4" />
                        <p className="mt-8 text-gray-300 text-lg max-w-sm">{data.desc}</p>
                    </div>

                    {/* 右侧导航 */}
                    <div className="px-4 w-full md:w-auto md:ml-auto grid grid-cols-3 gap-x-20 gap-y-6">
                        {data.navigation.map((section, idx) => (
                            <div key={idx} className="max-w-[140px]">
                                <h4 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-5 md:mb-9">{section.title}</h4> {/* 标题大屏更大，间距更宽 */}
                                <ul className="space-y-1 md:space-y-2 text-gray-300 text-sm md:text-base lg:text-base">
                                    {section.items.map((item, idx2) => (
                                        <li key={idx2}>
                                            <a
                                                href={item.path}
                                                target={item.target || "_self"}
                                                className="hover:text-white"
                                            >
                                                {item.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 白线 */}
                <div className="border-t border-gray-700 mt-10 mb-6"></div>

                {/* 下部分：Subscribe + 社交图标 */}
                <div className="mt-10 md:mt-14 flex flex-col md:flex-row justify-between items-center gap-6">
                    {/* Subscribe 表单 */}
                    <form
                        action="https://formspree.io/f/mzbygkoz"
                        method="POST"
                        className="relative w-full sm:w-[420px] md:w-[460px]"
                    >
                        <input
                            type="email"
                            name="message"
                            placeholder={data.PromptWord}
                            required
                            className="w-full pl-4 pr-28 py-4 md:py-5 text-gray-900 bg-white outline-none rounded-md text-base md:text-xl"
                        />
                        <button
                            type="submit"
                            className="absolute top-1/2 right-2 md:right-1 lg:right-2 -translate-y-1/2 bg-blue-500 text-white px-3 py-2 md:px-4 md:py-3 rounded-md hover:bg-blue-700 transition text-base md:text-lg"
                        >
                            {data.buttonTitle}
                        </button>
                    </form>

                    {/* 社交图标 */}
                    <div className="flex gap-3 sm:gap-4 lg:gap-8 justify-center md:justify-end md:w-1/2">
                        {data.socials.map((item, idx) => (
                            <a
                                key={idx}
                                href={item.link}
                                target={item.name}
                                rel="noopener noreferrer"
                                className="bg-gray-700 rounded-full p-2 sm:p-2.5 lg:p-3 hover:opacity-80 transition"
                            >
                                <img
                                    src={item.icon}
                                    alt={item.name}
                                    className="w-5 h-5 sm:w-6 sm:h-6 lg:w-6 lg:h-6"
                                />
                            </a>
                        ))}
                    </div>

                </div>

                {/* 联系方式和版权信息 */}
                <div className="mt-14 flex flex-col md:flex-row justify-between items-center text-gray-300 text-lg pb-2 gap-2 text-center md:text-left">
                    <p>Contact Us : contact@memolabs.org</p>
                    <p>© 2025 MemoLabs Inc. All rights reserved.</p>
                </div>

            </div>
        </footer >
    );
};

export default Footer;
